import Joi from "joi";
import moment from "moment";
import { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  getTrainingCategories,
  getAllTrainingInformation,
  getUserPageBlocks,
} from "../../../../../action/common/commonActionCreator";
import { updateTrainingBlock } from "../../../../../action/masters/trainingActionCreator";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import FloatingLabelTextInput from "../../../../../common-components/floatingtextinput";
import MultipleSelect from "../../../../../common-components/multipleSelect";
import {
  baseURL,
  cloneDeep,
  maxImageSize,
  urlRegex,
} from "../../../../../constants/commonConstants";
import { validateFields } from "../../../../../helper/joi-validation";
import {
  getAlertData,
  alertConstants,
} from "../../../../../helper/sweet-alert";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import {
  IEditTrainingBlock,
  ITrainingBlockEditData,
} from "../../../../../models/master/training";
import { setTrainigBlock } from "../../../../../store/slices/master/trainingBlockSlice";
import LoaderSpinner from "../../../../../common-components/loader";
import { masterType } from "../../../../../constants/masterTypes";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { setPageBlocks } from "../../../../../store/slices/common/commonSlice";
import { areObjectsEqual } from "../../../../../helper/generic-helpers";

const EditTrainingBlock = (props: IEditTrainingBlock) => {
  const dispatch = useDispatch();
  const {
    updateTrainingBlock,
    setShowEdit,
    pageBlocks,
    trainingBlock,
    getAllTrainingBlocks,
    getAllTrainingCategory,
    getAllTrainingKeyValuPairDescritionWithDate,
    trainingCategories,
    trainingKeyValuPairDescritionWithDate,
    getUserPageBlocks,
    userDetails,
  } = props;

  // states

  const [data, setData] = useState<ITrainingBlockEditData>(
    cloneDeep(trainingBlock || {})
  );
  const [initialData, setInitialData] = useState<
    ITrainingBlockEditData | undefined
  >(undefined);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageName, setImageName] = useState<string | null | undefined>(null);
  const [locationStatus, setLocationStatus] = useState<boolean>(true);
  // const ssoOptionsList = Object.entries(booleanOptions).map(([key, value]) => ({
  //   id: value,
  //   name: key,
  // }));
  // const [isSSOEnabled, setIsSSOEnabled] = useState<boolean>(false);
  const [onlineStatus, setOnlineStatus] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [hasChange, setHasChange] = useState(false);

  // change the data at the time onchange fields
  const onChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    errors && delete errors[event.target.name];
    let _data = { ...data, [event.target.name]: event.target.value };
    if (event.target.type === "radio") {
      if (event.target.id === "isMandatory") {
        _data.isMandatory = true;
      } else if (event.target.id === "isNotMandatory") {
        _data.isMandatory = false;
      }

      if (event.target.id === "isAttendInPerson") {
        _data.isAttendInPerson = true;
      } else if (event.target.id === "isNotAttendInPerson") {
        _data.isAttendInPerson = false;
      }

      if (event.target.id === "isOnline") {
        _data.isOnline = true;
        setLocationStatus(true);
      } else if (event.target.id === "isNotOnline") {
        _data.isOnline = false;
        setOnlineStatus(_data.isOnline);
      }
    }

    if (event.target.name === "name") {
      let _item =
        trainingKeyValuPairDescritionWithDate &&
        trainingKeyValuPairDescritionWithDate.find(
          (training) => training.id === event.target.value
        );
      _data.name = _item?.name;
      _data.description = _item?.name ? _item?.description : "";
      _data.trainingDate = _item?.name ? _item?.date : "";
      if (_data.description) errors && delete errors["description"];
      if (_data.trainingDate) errors && delete errors["trainingDate"];
    }
    setData(_data);
  };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    errors && delete errors[event.target.name];
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setImageName(selectedFile.name.trim().split("/").pop());
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      const validFileTypes = [
        "image/png",
        "image/ico",
        "image/svg+xml",
        "image/x-icon",
      ];
      if (!validFileTypes.includes(fileType)) {
        setErrors({
          ...errors,
          file: "Invalid file type. Please upload an icon.",
        });
      } else if (fileSize > maxImageSize) {
        setErrors({
          ...errors,
          file: "File size exceeds 1MB. Please upload a small file.",
        });
        setImagePreview(null);
        setImageName(null);
      } else {
        setData({ ...data, [event.target.name]: selectedFile });
        const fileURL = URL.createObjectURL(selectedFile);
        setImagePreview(fileURL);
      }
    }
  };

  useEffect(() => {
    if (trainingBlock) {
      let _trainingBlock = cloneDeep(trainingBlock);
      _trainingBlock.trainingDate =
        _trainingBlock.trainingDate &&
        moment(_trainingBlock.trainingDate).format("YYYY-MM-DD");
      _trainingBlock.endDate =
        _trainingBlock.endDate &&
        moment(_trainingBlock.endDate).format("YYYY-MM-DD");
      setData(_trainingBlock);
      setInitialData(_trainingBlock);
      if (_trainingBlock.image) {
        const imageUrl = baseURL + _trainingBlock.image;
        setImageName(_trainingBlock.image);
        setImagePreview(imageUrl);
      }
      // if (_trainingBlock.sso) {
      //   setIsSSOEnabled(true);
      // }
      setOnlineStatus(_trainingBlock.isOnline);
    }
  }, [trainingBlock]);

  // setting sweet alert dynamically
  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  // executed on clicking 'OK' in sweet alert.
  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else {
      getAllTrainingBlocks();
      setShowEdit(false);
    }
  };

  const schema = Joi.object().keys({
    name: Joi.string().required().label("Select Training Name"),
    description: Joi.string().required().label("Description is required"),
    linkToAttendTraining: Joi.string().when("isOnline", {
      is: true,
      then: Joi.string().required().regex(urlRegex).label("Enter Valid Link"),
      otherwise: Joi.string().allow("").optional(),
    }),
    trainingCategory: Joi.number()
      .greater(0)
      .required()
      .label("Select Training Category"),
    registrationLink: Joi.string()
      .required()
      .regex(urlRegex)
      .label("Enter Valid Registration Link"),
    file: Joi.any().when("isFile", {
      is: true,
      then: Joi.any().optional(),
      otherwise: Joi.any().required().label("File is required"),
    }),
    sso: Joi.string().when("isSSOEnabled", {
      is: true,
      then: Joi.string().required().regex(urlRegex).label("Enter Valid SSO"),
      otherwise: Joi.string().allow("", null).optional(),
    }),
    location: Joi.string().when("isOnline", {
      is: false,
      then: Joi.string().required().label("Location is required"),
      otherwise: Joi.string().allow("", null).optional(),
    }),
  });

  const validationData = {
    ...data,
    isFile: Boolean(data.file),
    // isSSOEnabled: isSSOEnabled,
    onlineStatus: onlineStatus,
  };

  const onUpdate = async () => {
    if (data.endDate) {
      data.endDate && console.log("date" + data.endDate.toString());
    }
    const validationErrors = validateFields(validationData, schema);
    if (validationErrors === undefined) {
      const formData = new FormData();
      formData.append("id", data.id?.toString() || "");
      formData.append("name", data.name);
      formData.append("file", data.file);
      // isSSOEnabled
      //   ? formData.append("sso", data.sso)
      //   : formData.append("sso", "");
      formData.append("isActive", "true");
      formData.append("isMandatory", data.isMandatory.toString());
      formData.append("isAttendInPerson", data.isAttendInPerson.toString());
      formData.append("trainingDate", data.trainingDate.toString());
      formData.append("endDate", data.endDate ? data.endDate.toString() : "");
      formData.append("linkToAttendTraining", data.linkToAttendTraining);
      formData.append("trainingCategory", data.trainingCategory.toString());
      formData.append("priority", data.priority.toString());
      formData.append(
        "description",
        data.description.replace(/\s+$/g, "").toString()
      );
      formData.append("registrationLink", data.registrationLink);
      formData.append("collegeId", userDetails.currentCollege.id.toString());
      formData.append(
        "departmentId",
        userDetails.currentDepartment.id.toString()
      );
      formData.append("location", data.location ? data.location : "");
      formData.append("isOnline", data.isOnline.toString());
      data.pageBlockIds.map((item, index) => {
        formData.append(`pageBlockIds[${index}]`, item.toString());
      });
      setLoading(true);
      setIsDisabled(true);
      try {
        await updateTrainingBlock(formData, data.id ?? 0, setAlert);
      } finally {
        setLoading(false);
        setIsDisabled(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  useEffect(() => {
    if (data && initialData) {
      setHasChange(!areObjectsEqual(data, initialData));
    }
  }, [data, initialData]);

  useEffect(() => {
    getUserPageBlocks(UserTypes.Staff, masterType.training);
    getAllTrainingCategory && getAllTrainingCategory();
    getAllTrainingKeyValuPairDescritionWithDate &&
      getAllTrainingKeyValuPairDescritionWithDate();
    return () => {
      dispatch(setTrainigBlock(undefined));
      dispatch(setPageBlocks([]));
    };
  }, []);

  const onChangeDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    errors && delete errors[name];
    const updatedData = { ...data, [name]: value };

    // Validate dates
    if (name === "endDate" && value < updatedData.trainingDate) {
      setErrors({
        ...errors,
        endDate: "End date cannot be earlier than the start date.",
      });
    } else if (
      name === "trainingDate" &&
      updatedData.endDate &&
      updatedData.endDate < value
    ) {
      setErrors({ ...errors, endDate: "Please adjust the end date." });
      updatedData.endDate = "";
    }
    setData(updatedData);
  };

  return (
    <>
      {data && (
        <>
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
              Update Training Block
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowEdit(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6 form-group">
                <FloatingLabelDropDown
                  label={"Training Category "}
                  onChange={onChange}
                  isMandatory={true}
                  value={data.trainingCategory}
                  name={"trainingCategory"}
                  optionsList={sortAlphabetically(trainingCategories)}
                />
                {errors?.trainingCategory && (
                  <div className="text-danger">{errors.trainingCategory}</div>
                )}
              </div>
              <div className="col-md-6 form-group">
                <div className="d-flex">
                  <label className="profile_details_text">
                    Icon<i className="label-asterisk"> * </i>
                  </label>
                  <p className="ms-2 label-info">
                    <i className="fa-solid fa-circle-info"></i>
                    <span>
                      Upload an icon (SVG, PNG, or ICO). For best results, use a
                      square shape with a transparent background.
                    </span>
                  </p>
                </div>
                <div className="inputfile-flex">
                  {imagePreview && (
                    <div className="inputfile-img">
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  )}
                  <div className="inputfile-wrap">
                    <input
                      type="file"
                      name="file"
                      id="image"
                      className="form-control d-none"
                      required
                      onChange={onFileChange}
                      accept="image/png, image/svg+xml, image/x-icon, image/ico, .svg, .png, .ico,"
                    />
                    <div className="inputfile">
                      <label htmlFor="image">Choose File</label>
                      <span>{imageName ? imageName : "No File Choosen"}</span>
                    </div>
                  </div>
                </div>
                {errors?.file && (
                  <div className="text-danger">{errors.file}</div>
                )}
              </div>
              <div className="col-md-12 form-group">
                <FloatingLabelDropDown
                  label={"Training Name "}
                  onChange={onChange}
                  isMandatory={true}
                  value={data.name}
                  name={"name"}
                  optionsList={sortAlphabetically(
                    trainingKeyValuPairDescritionWithDate
                  )}
                />
                {errors?.name && (
                  <div className="text-danger">{errors.name}</div>
                )}
              </div>

              <div className="col-md-12 form-group">
                <label className="profile_details_text">
                  Training Description
                </label>
                <textarea
                  name="description"
                  value={data.description}
                  onChange={onChange}
                  maxLength={1000}
                ></textarea>
                {errors?.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>

              <div className="col-md-6 form-group">
                <label className="profile_details_text">Mandatory</label>
                <div className="btn-flex pt-2 justify-content-start">
                  <div className="btn-group">
                    <div className="bch-radio">
                      <input
                        id="isMandatory"
                        type="radio"
                        name="isMandatory"
                        checked={data.isMandatory}
                        onChange={onChange}
                      />
                      <label htmlFor="isMandatory">
                        <span>Yes</span>
                      </label>
                    </div>
                    <div className="bch-radio">
                      <input
                        id="isNotMandatory"
                        type="radio"
                        name="isMandatory"
                        checked={!data.isMandatory}
                        onChange={onChange}
                      />
                      <label htmlFor="isNotMandatory">
                        <span>No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 form-group">
                <label className="profile_details_text">Attend in Person</label>
                <div className="btn-flex pt-2 justify-content-start">
                  <div className="btn-group">
                    <div className="bch-radio">
                      <input
                        id="isAttendInPerson"
                        type="radio"
                        name="isAttendInPerson"
                        checked={data.isAttendInPerson}
                        onChange={onChange}
                      />
                      <label htmlFor="isAttendInPerson">
                        <span> Yes</span>
                      </label>
                    </div>
                    <div className="bch-radio">
                      <input
                        id="isNotAttendInPerson"
                        type="radio"
                        name="isAttendInPerson"
                        checked={!data.isAttendInPerson}
                        onChange={onChange}
                      />
                      <label htmlFor="isNotAttendInPerson">
                        <span>No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 form-group">
                <label className="profile_details_text">Online</label>
                <div className="btn-flex pt-2 justify-content-start">
                  <div className="btn-group">
                    <div className="bch-radio">
                      <input
                        id="isOnline"
                        type="radio"
                        name="isOnline"
                        checked={data.isOnline}
                        onChange={onChange}
                      />
                      <label htmlFor="isOnline">
                        <span> Yes</span>
                      </label>
                    </div>
                    <div className="bch-radio">
                      <input
                        id="isNotOnline"
                        type="radio"
                        name="isOnline"
                        checked={!data.isOnline}
                        onChange={onChange}
                      />
                      <label htmlFor="isNotOnline">
                        <span>No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 form-group">
                <label className="profile_details_text">Training Date</label>
                <input
                  type="date"
                  name="trainingDate"
                  className="form-control"
                  onChange={onChangeDate}
                  value={data.trainingDate}
                  min={new Date().toISOString().split("T")[0]}
                />
                {errors?.trainingDate && (
                  <div className="text-danger">{errors.trainingDate}</div>
                )}
              </div>
              <div className="col-md-6 form-group">
                <label className="profile_details_text">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  className="form-control"
                  onChange={onChangeDate}
                  value={data.endDate}
                  min={data.trainingDate}
                />
              </div>
              {/* <div className="col-md-6 form-group">
                <FloatingLabelDropDown
                  label={"Is SSO Enabled"}
                  onChange={(e: any) => setIsSSOEnabled(e.target.value)}
                  isMandatory={true}
                  value={isSSOEnabled}
                  name={"isSSOEnabled"}
                  optionsList={ssoOptionsList}
                />
              </div>
              {isSSOEnabled && (
                <div className="col-md-6 form-group">
                  <FloatingLabelTextInput
                    label={"SSO"}
                    onChange={onChange}
                    isMandatory={true}
                    value={data.sso}
                    name={"sso"}
                    maxLength={500}
                  />
                  {errors?.sso && (
                    <div className="text-danger">{errors.sso}</div>
                  )}
                </div>
              )} */}
              <div className="col-md-6 form-group">
                <FloatingLabelTextInput
                  label={"Link to attend the training "}
                  onChange={onChange}
                  isMandatory={data.isOnline}
                  value={data.linkToAttendTraining}
                  name={"linkToAttendTraining"}
                  maxLength={500}
                  disable={!data.isOnline}
                />
                {errors?.linkToAttendTraining && (
                  <div className="text-danger">
                    {errors.linkToAttendTraining}
                  </div>
                )}
              </div>
              <div className="col-md-6 form-group">
                <FloatingLabelTextInput
                  label={"Registration Link "}
                  onChange={onChange}
                  isMandatory={true}
                  value={data.registrationLink}
                  name={"registrationLink"}
                  maxLength={500}
                />
                {errors?.registrationLink && (
                  <div className="text-danger">{errors.registrationLink}</div>
                )}
              </div>

              <div className="col-md-6 form-group">
                <FloatingLabelTextInput
                  label={"College Name "}
                  onChange={onChange}
                  isMandatory={true}
                  value={userDetails?.currentCollege?.name}
                  name={"collegeId"}
                  disable
                />
              </div>
              <div className="col-md-6 form-group">
                <FloatingLabelTextInput
                  label={"Department Name "}
                  onChange={onChange}
                  isMandatory={true}
                  value={userDetails?.currentDepartment?.name}
                  name={"departmentId"}
                  disable
                />
              </div>
              <div className="col-md-6 form-group">
                <FloatingLabelTextInput
                  label={"Page-Block "}
                  onChange={onChange}
                  isMandatory={false}
                  value={pageBlocks[0]?.name}
                  name={"pageBlockIds"}
                  disable
                />
              </div>
              <div
                // className={
                //   isSSOEnabled === true
                //     ? "col-md-12 form-group"
                //     : "col-md-6 form-group"
                // }
                className="col-md-12 form-group"
              >
                <FloatingLabelTextInput
                  label={"Location "}
                  onChange={onChange}
                  isMandatory={!data.isOnline}
                  value={data.location}
                  name={"location"}
                  disable={data.isOnline}
                  maxLength={50}
                />
                {errors?.location && (
                  <div className="text-danger">{errors.location}</div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onUpdate}
                disabled={isDisabled || !hasChange}
              >
                Update
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setShowEdit(false)}
                disabled={isDisabled}
              >
                Close
              </button>
            </div>
          </div>
          <SweetAlert
            show={showAlert}
            success={false}
            type={alertType}
            title={alertTitle}
            onConfirm={() => onConfirm()}
            showCancel={showAlertCancel}
            onCancel={() => {
              setShowAlert(false);
              setShowAlertCancel(false);
            }}
            cancelBtnText={"No"}
            confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
          ></SweetAlert>
          {loading && <LoaderSpinner />}
        </>
      )}
    </>
  );
};

const mapDispatchToProps = {
  updateTrainingBlock: (data: any, id: number, callBack: Function) =>
    updateTrainingBlock(data, id, callBack),
  getAllTrainingCategory: () => getTrainingCategories(),
  getAllTrainingKeyValuPairDescritionWithDate: () =>
    getAllTrainingInformation(),
  getUserPageBlocks: (userType: number, masterType: string) =>
    getUserPageBlocks(userType, masterType),
};

function mapStateToProps(state: any) {
  return {
    pageBlocks: state.common.pageBlocks,
    trainingCategories: state.common.trainingcategories,
    trainingKeyValuPairDescritionWithDate:
      state.common.trainingNameWithDescriptionAndDate,
    userDetails: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTrainingBlock);
